<!-- Hero Section -->
<app-hero-section></app-hero-section>

<!-- Carousel Section -->
<app-carousel></app-carousel>

<!-- Search Card Section -->
<app-search-card></app-search-card>

<!-- Making an Impact Section -->
<div id="impactSection" class="container mt-5 pb-5">
  <div class="row">
    <div class="col-md-8 pb-3">
      <h1 style="color: #002a60">Making an Impact</h1>
    </div>
  </div>
  <!-- Card Row -->
  <app-making-an-impact-cards></app-making-an-impact-cards>
</div>

<hr>
<!-- News and Media Section -->
<div id="latestNews" class="container mt-5 pb-5">
  <app-news-and-current-affairs></app-news-and-current-affairs>
</div>

<!-- Businessess Logo Section -->
<app-business-logo></app-business-logo>